import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
class ProofOfDeliveryInformationResource extends BaseResource {
    pk() {
        return this.applicationId?.toString();
    }
}
ProofOfDeliveryInformationResource.urlRoot = legacyApiResourceUrl("ProofOfDelivery/Info");
export { ProofOfDeliveryInformationResource };
//# sourceMappingURL=ProofOfDeliverySmsResources.js.map